<template>
    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Stammdaten') }}</legend>
                            <text-input label="name" v-model="form.name" :error="form.errors.name" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Kontakt') }}</legend>
                            <text-input type="email" label="email" v-model="form.email" :error="form.errors.email" />
                            <text-input type="tel" label="phone" v-model="form.phone" :error="form.errors.phone" />
                            <text-input type="tel" label="fax" v-model="form.fax" :error="form.errors.fax" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Sonstiges') }}</legend>
                            <textarea-input label="notes" v-model="form.notes" :error="form.errors.notes" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="admin">
                    {{ __('Put in trash') }}
                </button>
            </div>

        </div>

    </div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'admin',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            destroy() {
                this.$inertia.delete(this.route('admin.admins.destroy', this.admin));
            },
        },
    }
</script>
